export default {
      id: "naver-small-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#naver-small",
      toString: function () {
        return this.url;
      }
    }